import Base from "../../base";
import SideMenu from "../SideMenu";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import LeftMenu from "../../../components/LeftMenu";
import Header from "../Header";
import { useForm } from "react-hook-form";
import axiosConfig from "../../../services/Axios";
import Title from "../../../components/ui/Title";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faImages,
  faDolly,
  faCircleInfo,
  faCubes,
  faTriangleExclamation,
  faHandshake,
  faListCheck,
} from "@fortawesome/pro-regular-svg-icons";
import ItemForm from "./Form";
import ItemPackageWizard from "./ItemPackageWizard";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import ItemDescription from "./Description";
import ItemPictureForm from "./ItemPictureForm";
import PicturesList from "./PicturesList";
import ItemPackages from "./ItemPackages";
import SelectItemStates from "../../../components/ui/Selects/ItemStates";
import { useSelector } from "react-redux";
import ItemState from "../../../components/ui/ItemState";
import ItemPartner from "./ItemPartner";
import dayjs from "dayjs";
import useTailwindBreakpoint from "../../../hooks/useTailwindBreakpoint";
import ItemOrderList from "./ItemOrderList";

function ItemEditForm() {
  let { id } = useParams();
  const form = useForm();
  const [item, setItem] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [definePackaging, setDefinePackaging] = useState(false);
  const authUser = useSelector((state) => state.auth);
  const isAdmin = authUser?.user?.roles.includes("ROLE_ADMIN");
  const [modalPictureFormIsOpen, setModalPictureFormIsOpen] = useState(false);
  const { t, i18n } = useTranslation();

  const openModalPictureUpload = (item) => {
    setModalPictureFormIsOpen(true);
  };
  const currentBp = useTailwindBreakpoint();

  useEffect(() => {
    if (!modalPictureFormIsOpen) {
    }
  }, [modalPictureFormIsOpen]);

  useEffect(() => {
    axiosConfig
      .get(process.env.REACT_APP_API_URL + "/api/items/" + id)
      .then((response) => {
        if (response?.status === 200 && response?.data) {
          setItem(response.data);
        }
      });
  }, []);

  const onSubmit = async (data) => {
    data.useByDate
      ? (data.useByDate = dayjs(data.useByDate).locale(i18n.language))
      : "";
    try {
      await axiosConfig
        .patch(process.env.REACT_APP_API_URL + item["@id"], data, {
          headers: { "Content-Type": "application/merge-patch+json" },
        })
        .then((response) => {
          if (response?.status === 200 && response?.data) {
            toast.success(t("settings.items.updated"), {
              theme: "colored",
              hideProgressBar: true,
            });
            setEditMode(false);
            setItem(response.data);
          }
        });
    } catch (e) {
      if (e.response.status !== 200) {
        if (e.response.data?.violations) {
          e.response.data.violations.map((v) => {
            form.setError(v.propertyPath, {
              type: "manual",
              message: v.message,
            });
          });
        } else {
          toast.error(e.response.data["hydra:description"], {
            theme: "colored",
            hideProgressBar: true,
          });
        }
      }
    }
  };

  const updateState = async (state) => {
    Swal.fire({
      text: t("items.changeStateQuestion", {
        previous_state: t("items.state." + item.state),
        state: t("items.state." + state),
      }),
      icon: "question",
      showCancelButton: true,
      confirmButtonText: t("global.btn.confirm_modify"),
      cancelButtonText: t("global.btn.cancel"),
      customClass: {
        actions: "gap-2 h-20",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          axiosConfig
            .patch(
              process.env.REACT_APP_API_URL + item["@id"],
              {
                state,
              },
              {
                headers: { "Content-Type": "application/merge-patch+json" },
              }
            )
            .then((response) => {
              if (response?.status === 200 && response?.data) {
                toast.success(t("settings.items.updated"), {
                  theme: "colored",
                  hideProgressBar: true,
                });
                setItem(response.data);
              }
            });
        } catch (e) {
          console.log(e);
        }
      }
    });
  };

  return (
    <Base>
      <Header />
      <div className="py-16 container m-auto px-6 grid grid-cols-12">
        <div className="col-span-12 lg:col-span-3 xl:col-span-2">
          <LeftMenu menu={SideMenu} />
        </div>
        <div className="lg:ml-6 text-sm mt-4 lg:mt-0 col-span-12 lg:col-span-9 xl:col-span-10">
          <div className="lg:p-8 lg:px-10 lg:bg-white rounded-lg">
            {item && (
              <>
                {isAdmin && (
                  <div className="text-right italic text-gray-700 text-xs lg:text-sm mb-5">
                    <p>
                      {t("global.create_info", {
                        createUser: item.createdBy?.email,
                        createDate: dayjs(item.createdAt).format(
                          "DD/MM/YYYY HH:mm"
                        ),
                      })}
                    </p>
                    {item.updatedBy && (
                      <p>
                        {t("global.update_info", {
                          updateUser: item.updatedBy.email,
                          updateDate: dayjs(item.updatedAt).format(
                            "DD/MM/YYYY HH:mm"
                          ),
                        })}
                      </p>
                    )}
                  </div>
                )}

                {["sm", "md", "lg"].includes(currentBp) ? (
                  <div>
                    <Title icon={faDolly} title={item.name.toUpperCase()} />
                    {isAdmin && (
                      <div className="flex items-center mb-4 lg:mb-0 ">
                        <div className="text-sm font-normal w-full mr-0 lg:w-60 lg:mr-4">
                          <SelectItemStates
                            onChange={(e) => updateState(e)}
                            value={item.state}
                          />
                        </div>
                        <ItemState
                          item={item}
                          className={
                            "ml-2 lg:ml-0 px-4 py-2 text-sm font-normal"
                          }
                        />
                      </div>
                    )}
                  </div>
                ) : (
                  <Title
                    icon={faDolly}
                    title={item.name.toUpperCase()}
                    otherAction={
                      <div className="flex items-center">
                        {isAdmin && (
                          <div className="text-sm font-normal w-60 mr-4">
                            <SelectItemStates
                              onChange={(e) => updateState(e)}
                              value={item.state}
                            />
                          </div>
                        )}
                        <ItemState
                          item={item}
                          className={"px-4 py-2 text-sm font-normal"}
                        />
                      </div>
                    }
                  />
                )}
                <div className="text-sm whitespace-pre-wrap">
                  {item.description}
                </div>
                {item.state !== "draft" && !isAdmin && (
                  <div className="whitespace-pre-wrap text-red-500 text-center mt-4 font-bold">
                    <FontAwesomeIcon
                      icon={faTriangleExclamation}
                      className="mr-1"
                      size="lg"
                    />
                    {t("items.message_edit")}
                  </div>
                )}
                <Title
                  icon={faCircleInfo}
                  title={t("items.technicalInfos")}
                  className="mt-12"
                  small={true}
                  button={
                    !editMode && (item.state === "draft" || isAdmin)
                      ? {
                          label: t("global.btn.edit"),
                          fn: () => setEditMode(!editMode),
                        }
                      : null
                  }
                />

                <div className="px-0 lg:px-6">
                  {editMode ? (
                    <div className="mt-8 bg-gray-100 rounded-lg lg:px-8 py-5">
                      <ItemForm
                        form={form}
                        item={item}
                        onSubmit={onSubmit}
                        onCancel={() => setEditMode(false)}
                      />
                    </div>
                  ) : (
                    <ItemDescription item={item} />
                  )}
                </div>

                <Title
                  icon={faCubes}
                  title={t("items.packaging")}
                  className="mt-12"
                  small={true}
                  button={
                    !definePackaging &&
                    item.itemPackages.length === 0 &&
                    (item.state === "draft" || isAdmin)
                      ? {
                          label: t("settings.items.definePackaging"),
                          fn: () => setDefinePackaging(!definePackaging),
                        }
                      : null
                  }
                />

                {definePackaging ? (
                  <div className="bg-gray-100 rounded-lg lg:px-8 py-5">
                    <ItemPackageWizard
                      item={item}
                      setItem={setItem}
                      setDefinePackaging={setDefinePackaging}
                    />
                  </div>
                ) : (
                  <ItemPackages
                    item={item}
                    setItem={setItem}
                    setDefinePackaging={setDefinePackaging}
                    definePackaging={definePackaging}
                    isAdmin={isAdmin}
                  />
                )}

                <Title
                  icon={faImages}
                  title={t("items.pictures")}
                  className="mt-12"
                  small={true}
                  button={
                    !editMode && (item.state === "draft" || isAdmin)
                      ? {
                          label: t("settings.items.uploadPicture"),
                          fn: () => openModalPictureUpload(item),
                        }
                      : null
                  }
                />
                <div className="flex justify-left">
                  <PicturesList
                    item={item}
                    setItemSelected={setItem}
                    itemSelected={item}
                    isAdmin={isAdmin}
                    editMode={editMode}
                  />
                </div>

                <Title
                  icon={faHandshake}
                  title={t("items.partner")}
                  className="mt-12"
                  small={true}
                />
                <ItemPartner item={item} />

                {isAdmin && item.state === "online" && (
                  <>
                    <Title
                      icon={faListCheck}
                      title={t("items.orderCount", {
                        count: item.itemOrders.length,
                      })}
                      className="mt-12"
                      small={true}
                    />
                    {item.itemOrders && item.itemOrders.length > 0 ? (
                      <ItemOrderList itemOrders={item.itemOrders} />
                    ) : (
                      <div className="text-bioport-blue mt-4 text-center">
                        {t("items.no_order")}
                      </div>
                    )}
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      <ItemPictureForm
        setModalPictureFormIsOpen={setModalPictureFormIsOpen}
        modalPictureFormIsOpen={modalPictureFormIsOpen}
        setItemSelected={setItem}
        itemSelected={item}
        hidePictures={true}
      />
    </Base>
  );
}

export default ItemEditForm;
